// side-nav
export const PUSH_TO_DMS_BUTTON_TEXT = 'Push to DMS';
export const RESEND_TO_DMS_BUTTON_TEXT = 'Resend to DMS';
export const RE_PUSH_TO_DMS_BUTTON_TEXT = 'Re-Push To DMS';
// modal
export const DIALOG_HEADER_INTERSTATE = 'Push To DMS';
export const DIALOG_HEADER = 'Confirm Push to DMS';
export const PUSH_TO_DMS_DIALOG_HEADER = 'Push to DMS';
export const DIALOG_PROMPT = 'Make sure all financial and contracting activities have been completed before pushing to DMS.';
export const ALERT_SUCCESS_MESSAGE = 'Push to DMS was successful.';
export const ALERT_SUCCESS_DEALAPI_ONLY_MESSAGE = 'Handoff of deal details to DMS has been initiated.';
export const LOADING_TEXT = 'Pushing to DMS';
export const LOADING_TEXT_INTERSTATE = 'Updating...';
export const CANCEL_BUTTON_TEXT = 'Cancel';
export const CONFIRM_BUTTON_TEXT = 'Confirm';
export const DONE_BUTTON_TEXT = 'Done';
export const CLOSE_BUTTON_TEXT = 'Close';
export const PUSH_ERROR_DIALOG_HEADER = 'Push To DMS Failed';
export const PUSH_ERROR_DIALOG_HEADER_INTERSTATE = 'Push To DMS Failed.';
export const PUSH_VIN_ERROR_DIALOG_MESSAGE = 'You must enter a full 17 digit VIN for the trade-in vehicle.';
export const PUSH_STOCK_NUMBER_ERROR_DIALOG_MESSAGE = 'Please provide a valid stock number and try again.';
export const SHOW_WAITING_LOADER_TEXT = 'This will take a moment';
export const PUSH_SUCCESS_DEAL_ID = 'Deal ID';
export const PUSH_SUCCESS_VEHICLE_STOCK_NUMBER = 'Stock #';
export const PUSH_SUCCESS_VEHICLE_VIN = 'VIN #';
export const PUSH_CDMS_ERROR_MESSAGE = 'This deal could not be pushed to the DMS. Please try again.';
export const PUSH_DEAL_LOADED_EVENT = 'loaded';
export const PUSH_DEAL_CLICK_EVENT = 'push-deal-clicked';
export const PUSH_DEAL_CANCEL_EVENT = 'cancel';
export const PUSH_DEAL_CLOSE_ERROR_EVENT = 'close-error';
export const PUSH_DEAL_SUCCESS_EVENT = 'push-deal-success';
export const PUSH_DEAL_RESPONSE_EVENT = 'push-deal-response';
export const PUSH_DEAL_FAILED_EVENT = 'push-deal-failed';
